import { action, makeObservable, observable } from 'mobx';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { doBetStore } from './doBetStore';
import { winningAmountStore } from './winningAmountStore';

class GameStore {
  isBetsClosed = false;

  constructor() {
    makeObservable(this, {
      isBetsClosed: observable,
      setIsBetsClosed: action.bound,
      handleDemoSwitcher: action.bound,
    });
  }

  setIsBetsClosed(arg) {
    this.isBetsClosed = arg;
  }

  handleDemoSwitcher() {
    const { limits } = gameConfigStore;
    doBetStore.resetBetsModels();
    doBetStore.resetReBet();
    winningAmountStore.setWinType(null);
    winningAmountStore.setWinningAmount(null);
    winningAmountStore.setLastWin(0);
    doBetStore.setSelectedChip(limits.quickBets[0]);
  }
}

export const gameStore = new GameStore();
